import React from 'react'
import { DEFAULT_ACTIVITY_COLUMN_IDS, EVIDENCE_TACTICS_TABLE_SCOPE } from '../ActivityTable.constants'
import ActivityTabTable, { ActivityTabTableProps } from '../components/ActivityTabTable'

type EvidenceTacticsTableProps = Pick<ActivityTabTableProps, 'rows' | 'onOpenPanel' | 'onReorder'> & {
    activitiesLabel: string
    singularActivityLabel: string
}

export const EvidenceTacticsTable = ({
    activitiesLabel,
    singularActivityLabel,
    ...props
}: EvidenceTacticsTableProps) => (
    <ActivityTabTable
        {...props}
        scope={EVIDENCE_TACTICS_TABLE_SCOPE}
        defaultColumnIds={DEFAULT_ACTIVITY_COLUMN_IDS}
        searchPlaceholder={`${singularActivityLabel} Search`}
        noMatchesLabel={activitiesLabel.toLowerCase()}
        emptyTitle={`No ${activitiesLabel} to display`}
        emptySubtitle={`Click 'Add New' on the left panel to create a new ${singularActivityLabel}`}
    />
)

export default EvidenceTacticsTable
